import moment from 'moment-timezone';
import { convertUTCHourToOffsetHour } from './convertUTCHourToOffsetHour';

/**
 * Converts the UTC hour to another timezone's hour
 *
 * @param hour - The hour in UTC time
 * @param timezone - The timezone to convert to
 * @returns - The hour in the new timezone
 */
export function convertUTCHourToTimezoneHour(hour: number, timezone: string): number {
    return convertUTCHourToOffsetHour(hour, moment.tz(timezone).utcOffset());
}
